import script from "./OpenLoadView1.vue?vue&type=script&setup=true&lang=js"
export * from "./OpenLoadView1.vue?vue&type=script&setup=true&lang=js"

import "./OpenLoadView1.vue?vue&type=style&index=0&id=7a3177d6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a3177d6"]])

export default __exports__